/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

type Props = {
  subtitle?: string;
  icon?: React.ReactNode;
};

const styles = {
  icon: css`
    display: block;
  `,
  title: css`
    padding: var(--cds-spacing-100) 0;
  `,
};

const InstallationRequirementsDetailItem = ({ subtitle, icon }: Props) => {
  return (
    <React.Fragment>
      {icon && <span css={styles.icon}>{icon}</span>}
      <Typography2 variant="subtitleMedium" css={styles.title} component="div">
        {_t('No downloads or installation required')}
      </Typography2>
      {!!subtitle && (
        <Typography2 component="p" variant="bodySecondary" color="supportText">
          {subtitle}
        </Typography2>
      )}
    </React.Fragment>
  );
};

export default InstallationRequirementsDetailItem;
